'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form } from 'react-bootstrap';

const Globals = require('../../../../app/globals');

const propTypes = {
    serviceData: PropTypes.object,
    submitHandler: PropTypes.func.isRequired,
    closeHandler: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
};

const defaultProps = {
    show: true,
    readOnly: false
};

class EditBadgeServiceModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            serviceData: this.props.serviceData,
        };
    }

    submitHandler=(e)=>{
        this.props.submitHandler(this.state.serviceData);
    }
    
    render() {
        return (
            <Modal
                show={this.props.show}
                size="lg"
                enforceFocus={false}
                autoFocus
                backdrop={false}
                animation={false}
                keyboard
                onHide={this.props.closeHandler}
            >
                <Modal.Header closeButton onHide={this.props.closeHandler}>
                    <Modal.Title>
                        {this.props.readOnly ?
                            "View Badge Service Details"
                            :
                            "Edit Badge Service Details"
                        }
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form>
                        <Form.Group controlId="modal-edit-badge-service-endpoint">
                            <Form.Label>{'Base API'}</Form.Label>
                            <Form.Control
                                as={'input'}
                                aria-label={'Base Service API'}
                                value={this.state.serviceData.endpoints.base_api}
                                onChange={(e)=>{
                                    this.setState({ 
                                        serviceData: {
                                            ...this.state.serviceData,
                                            endpoints: {
                                                ...this.state.serviceData.endpoints,
                                                base_api: e.target.value 
                                            }
                                        }
                                    })
                                }}
                            />
                        </Form.Group>

                        <Form.Group controlId="modal-edit-badge-credential-org-id">
                            <Form.Label>{'Organization ID'}</Form.Label>
                            <Form.Control
                                as={'input'}
                                aria-label={'Org Id'}
                                value={this.state.serviceData.credentials.organization_id}
                                onChange={(e)=>{
                                    this.setState({ 
                                        serviceData: {
                                            ...this.state.serviceData,
                                            credentials: {
                                                ...this.state.serviceData.credentials,
                                                organization_id: e.target.value 
                                            }
                                        }
                                    })
                                }}
                            />
                        </Form.Group>

                        <Form.Group controlId="modal-edit-badge-credential-auth-token">
                            <Form.Label>{'Auth Token'}</Form.Label>
                            <Form.Control
                                as={'input'}
                                aria-label={'Auth Token'}
                                value={this.state.serviceData.credentials.token}
                                onChange={(e)=>{
                                    this.setState({ 
                                        serviceData: {
                                            ...this.state.serviceData,
                                            credentials: {
                                                ...this.state.serviceData.credentials,
                                                token: e.target.value 
                                            }
                                        }
                                    })
                                }}
                            />
                        </Form.Group>

                    </Form>
                </Modal.Body>

                <Modal.Footer>
                    {(!this.props.readOnly) &&
                        <Button onClick={this.submitHandler}>
                            set
                        </Button>
                    }
                </Modal.Footer>
            </Modal>
        );
    }
}

EditBadgeServiceModal.propTypes = propTypes;
EditBadgeServiceModal.defaultProps = defaultProps;

export default EditBadgeServiceModal;